import React from 'react'

export default function ArrowDownIcon({ size = 24 }) {

  return (
    <svg width={`${size + 3}px`} height={`${size}px`} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' ><path d='M12 16a1 1 0 0 1-.64-.23l-5-4a1.001 1.001 0 0 1 1.28-1.54L12 13.71l4.36-3.32a1.001 1.001 0 0 1 1.41.15 1 1 0 0 1-.14 1.46l-5 3.83A1 1 0 0 1 12 16Z' fill='currentColor'></path></svg>
  )
}